var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { fontFamily, giphyBlue, giphyLightGrey } from '@giphy/js-brand';
import React from 'react';
var Message = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    display: flex;\n    justify-content: center;\n    margin: 30px 0;\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: 600;\n    a {\n        color: ", ";\n        cursor: pointer;\n        &:hover {\n            color: white;\n        }\n    }\n"], ["\n    color: ", ";\n    display: flex;\n    justify-content: center;\n    margin: 30px 0;\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: 600;\n    a {\n        color: ", ";\n        cursor: pointer;\n        &:hover {\n            color: white;\n        }\n    }\n"])), giphyLightGrey, fontFamily.body, giphyBlue);
var FetchError = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(Message, null,
        "Error loading GIFs.\u00A0",
        React.createElement("a", { onClick: onClick }, "Try again?")));
};
export default FetchError;
var templateObject_1;
//# sourceMappingURL=fetch-error.js.map